import { i18n } from '@b2ag/locale'

export const generateLink = (rel: string, href: string, locale: string) => {
  return {
    rel,
    hreflang: i18n.locale === locale ? 'x-default' : locale,
    href: href.toLowerCase(),
  }
}
